import DefaultOverlay from "../pages/modules/DefaultOverlay";

import IM01 from "../pages/modules/IM01";

import MD01 from "../pages/modules/MD01";

import PR01 from "../pages/modules/PR01";
import PR02 from "../pages/modules/PR02";

import PT01 from "../pages/modules/PT01";

import TX01 from "../pages/modules/TX01";

import VT01 from "../pages/modules/VT01";

export const overlays = {
    IM01,

    MD01,

    PR01,
    PR02,

    PT01,

    TX01,

    VT01,

    DEFAULT: DefaultOverlay,
};
